
  <ng-content select="[quill-editor-toolbar]"></ng-content>



// WEBPACK FOOTER //
// ./~/ngx-quill/ngx-quill.d.ts.QuillEditorComponent.html